var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasServices)?_c('div',{staticClass:"flex flex-col divide-y"},[_vm._t("default",null,null,{ filteredServices: _vm.filteredServices })],2):_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"flex bg-gray-50 justify-center p-2 items-center rounded border text-sm text-gray-500"},[_vm._v(" "+_vm._s(_vm.noAvailMessage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }